import RegistrationConstants from "../../constants/RegistrationConstants";

var initialState = {
  name: '',
  phone_number: '',
  email: '',
  description: '',
  website: '',
  line1: '',
  line2: '',
  city: '',
  zip: '',
  longitude: '',
  latitude: '',
  types: []
};

export default function signForm(state = initialState, action) {
  switch (action.type) {
    case 'RESET_SIGN_FORM':
      return initialState;
    case RegistrationConstants.REG_SET_FIELD:
      return {
        ...state,
        [action.payload.name]: action.payload.value
      };
    default:
      break;
  }
  return state;
}



/** WEBPACK FOOTER **
 ** ./src/reducers/forms/signForm.js
 **/